import { mediaItems } from '@/mocks/homeData';

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          精彩花絮
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10">
          幕后故事与深度访谈，了解更多影片背后的精彩
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 border border-background-200/30 rounded-xl overflow-hidden hover:border-primary-500/25 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 80s电影网精彩花絮`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-950 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-foreground-100 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-100 line-clamp-2 leading-snug mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}